import { createClient } from '@supabase/supabase-js'

// Create a single supabase client for interacting with your database 
const supabase = createClient('https://awhgprllcsvvyylbrlan.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYzNzc1MjYyOSwiZXhwIjoxOTUzMzI4NjI5fQ.jAEKLkTys9XR-IAMyMGECB-DjVfMZJSiNd48yZOhZFU', {
    fetch: (...args) => fetch(...args)
})

export default supabase;